import React from 'react';
import './style.css';

import { ROUTE_NAMES } from '../../Routes';

import ImageGallery from 'react-image-gallery';
import { ImLocation } from 'react-icons/im';
import { FaArrowLeft } from 'react-icons/fa';

export default function ProjectInfoSection({ info }) {
  const paragraphs = info.text.split('\n\n');
  const images = info.images;

  const handleOpenProjectsPage = () => {
    window.location.href = ROUTE_NAMES.PROJECTS;
  };

  return (
    <div className='project-info-section'>
      <button className='go-back-btn' onClick={handleOpenProjectsPage}>
        <FaArrowLeft /> Go back to projects
      </button>
      <h1 className='service-page-title'>{info.title}</h1>
      {images.length === 1 ? (
        <img
          src={images[0].original}
          alt={info.title}
          className='single-image'
        />
      ) : (
        <ImageGallery
          items={images}
          showNav={false}
          showPlayButton={false}
          autoPlay={false}
        />
      )}
      <h3 className='project-page-location'>
        <ImLocation /> {info.location}
      </h3>
      {paragraphs.map((paragraph, index) => (
        <p className='project-page-info' key={index}>
          {paragraph}
        </p>
      ))}
      {info.link && (
        <a
          href={info.link}
          target='_blank'
          rel='noopener noreferrer'
          className='project-page-info project-link'
        >
          Learn more about the EB-5 investment program for foreign investors
        </a>
      )}
    </div>
  );
}
